module.exports = __webpack_public_path__ + "img/zidonghua.c558bce4.png";